import dwhExport from '~/dwhExport'
import Dialog from "@wg/wows-react-uikit/Dialog";
import Message from "@wg/wows-react-uikit/Message";
import Processing from "@wg/wows-react-uikit/Processing";
import { t } from 'helpers/localization'
import React, { PureComponent } from 'react'
import styles from './ViewClanTasks.scss'
import {ClanTask, ClanTaskReward} from "~/Actions/ActionClanTasks";
import TaskRow from "~/Components/ViewClanTasks/TaskRow/TaskRow";
import classNames from "classnames";
import settings from "settings";
import {iHavePermission, permissions} from "roles";
import {scrollToY} from "helpers/animate";
import {Button, ButtonGroup, DialogBody, DialogContainer, DialogFooter, DialogHeader} from "@wg/wows-react-uikit";
import {TASK_DESCRIPTIONS} from "~/Components/ViewClanTasks/constants";

const CONTENT_PADDING = 0;

export type ViewClanTasks_Props = {
  isFetching: boolean,
  isClaiming: boolean,
  tasks: Array<ClanTask>,
  claimed: Array<ClanTask>,
  claimClanTasks: () => void,
  claimClanTask: (taskId: number) => void,

  currentAccount?: any,
}

class ViewClanTasks extends PureComponent<ViewClanTasks_Props, any> {

  public _scrollContainer: HTMLDivElement
  public _tasksRefs: Array<TaskRow>

  constructor(props: ViewClanTasks_Props) {
    super(props)
    this.state = {
        firstOpen: true,
        isPromoScreenOpen: false,
        showShadowTop: false,
        showShadowBottom: false,
    }
    this._tasksRefs = []

    this.openPromoScreen = this.openPromoScreen.bind(this)
    this.closePromoScreen = this.closePromoScreen.bind(this)
  }

  public onScroll = (e: any) => {
      const scrollPosition = e.currentTarget.scrollTop;
      const scrollHeight = e.currentTarget.scrollHeight - e.currentTarget.clientHeight - CONTENT_PADDING;

      this.setState({
          showShadowTop: scrollPosition >= CONTENT_PADDING,
          showShadowBottom: scrollPosition <= scrollHeight,
      });
  }

  public componentDidMount() {
    dwhExport.send('clan_tasks')
    const containerHasScroll = this._scrollContainer ? (this._scrollContainer.scrollHeight > this._scrollContainer.clientHeight) : false;
    this.setState({ showShadowBottom: containerHasScroll });
    this._scrollContainer.addEventListener('scroll', this.onScroll);
  }

  public componentWillUnmount() {
    this._scrollContainer.removeEventListener('scroll', this.onScroll);
  }

  public componentDidUpdate(prevProps: Readonly<ViewClanTasks_Props>, prevState: Readonly<any>, snapshot?: any) {

    if (this.state.firstOpen) {
      const aggregatedReward = this.getAggregatedReward()
      this.setState({...this.state, firstOpen: false}, () => {
        if (aggregatedReward !== null) { setTimeout(this.openPromoScreen, 300) }
      })
    }

    const newClaimed = this.props.claimed.filter(task => !prevProps.claimed.includes(task))

    let delay = 0
    newClaimed.map(claimedTask => {
      const index = this.props.tasks.findIndex(task => task.name === claimedTask.name)
      if (index > -1) {
        setTimeout(() => {this.animateTaskRow(index, 500)}, delay)
        delay += 1300
      }
    })
  }

  public openPromoScreen() {
    this.setState({...this.state, isPromoScreenOpen: true})
  }

  public closePromoScreen() {
    this.setState({...this.state, isPromoScreenOpen: false})
  }

  public animateTaskRow(index: number, speed: number = 1000) {
    const rowHeight = 98
    scrollToY(this._scrollContainer, index * rowHeight + CONTENT_PADDING, speed)
    setTimeout(() => {
      const taskRow = this._tasksRefs[index]
      if (taskRow) { taskRow.animate() }
    }, speed)
  }

  public getAggregatedReward(): ClanTaskReward {
    const aggregatedReward: ClanTaskReward = {oil: 0, coal: 0}
    this.props.tasks.map((task: ClanTask) => {
      if (task.isFinished && !task.isClaimed && task.reward) {
        aggregatedReward.oil += task.reward.oil || 0
        aggregatedReward.coal += task.reward.coal || 0
      }
    })
    if (aggregatedReward.oil > 0 || aggregatedReward.coal > 0) {
      return aggregatedReward
    }
    return null
  }

  public renderPromoScreen() {
    const tasks = this.props.tasks
    const aggregatedReward = this.getAggregatedReward()
    if (aggregatedReward === null) { return null; }
    return (
      <Dialog
        content={
          <DialogContainer>
            <DialogHeader>{t('Полученные награды')}</DialogHeader>
            <DialogBody>
              <div className={styles.aggregateRewardDescription}>
                <span className={styles.aggregateRewardDescriptionSubTitle}>{t('Выполненные задачи клана:')}</span>
                <br />
                <span className={styles.aggregateRewardDescriptionTasks}>{tasks.filter(task => task.isFinished && !task.isClaimed).map(task => TASK_DESCRIPTIONS[task.name].title).join(', ')}</span>
                <br />
                <span className={styles.aggregateRewardDescriptionRewardTitle}>{t('Награда будет помещена в клановую казну.')}</span>
                <br />
                { aggregatedReward.coal ? <div className={styles.coal}><span>{aggregatedReward.coal}</span></div> : null }
                { aggregatedReward.oil ? <div className={styles.oil}><span>{aggregatedReward.oil}</span></div> : null }
              </div>
            </DialogBody>
            <DialogFooter>
              <ButtonGroup>
                <Button
                  isJustified
                  onClick={() => {
                    this.closePromoScreen()
                    this.props.claimClanTasks()
                  }}>
                  {t('Забрать награду')}
                </Button>
              </ButtonGroup>
            </DialogFooter>
          </DialogContainer>
        }
        size={'worship'}
        isOverlay={false}
        isVisible={this.state.isPromoScreenOpen}
        hideDialog={this.closePromoScreen}
        t={t}/>
    )
  }

  render() {
    const tasks = this.props.tasks

    const canClaimRewards = iHavePermission(permissions.CHANGE_SETTINGS, this.props.currentAccount)

    const syncMessage = t('Информация о прогрессе выполнения задач обновляется  ежедневно в {update_time} по серверному времени.').replace('{update_time}', settings.darwin.syncTime)

    const taskContainerClassName = classNames(styles.taskContainer, {
      [styles.showShadowTop]: this.state.showShadowTop,
      [styles.showShadowBottom]: this.state.showShadowBottom,
    });

    return (
      <div className={styles.wrapper}>
        <div style={{ display: this.props.isFetching ? 'none' : 'block' }}>
        <div className={styles.headImage} />
          <div className={styles.subWrapper}>
            <div className={styles.header}>
              <span className={styles.pageTitle}>{t('Задачи клана')}</span>
            </div>
            <div className={taskContainerClassName}>
              <div className={styles.taskContainerContent} ref={(c) => { if (c) { this._scrollContainer = c }}}>
                {tasks.map((task: ClanTask, index: number) => (
                  <TaskRow
                    key={task.taskId}
                    task={task}
                    canClaimRewards={canClaimRewards}
                    onClaim={() => {this.props.claimClanTask(task.taskId)}}
                    isClaiming={this.props.isClaiming}
                    ref={(c) => { if (c) { this._tasksRefs[index] = c }}}/>
                ))}
              </div>
            </div>
            <div className={styles.syncMessageWrapper}>
              <Message
                style="inline"
                type="confirmation" >&nbsp;&nbsp;{syncMessage}</Message>
            </div>
          </div>
        </div>
        <Processing isFetching={this.props.isFetching} label="" />
        {canClaimRewards ? this.renderPromoScreen() : null}
      </div>
    )
    }
}

ViewClanTasks.defaultProps = {
  isFetching: false,
  isClaiming: false,
  tasks: [],
  claimed: [],
  claimClanTasks: () => {},
  claimClanTask: (clanId: number) => {},
}

export default ViewClanTasks
